"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAddToFavorite = void 0;
const typescript_cookie_1 = require("typescript-cookie");
function addToFavorite(e, favoriteButton) {
    e.preventDefault();
    const vacancyId = favoriteButton.getAttribute('data-postid');
    const setFavorites = (0, typescript_cookie_1.getCookie)('favoriteVacancies');
    if (setFavorites !== undefined && setFavorites.includes(vacancyId)) {
        const cleanCookie = setFavorites.replace(',' + vacancyId, '').replace(vacancyId, '');
        (0, typescript_cookie_1.setCookie)('favoriteVacancies', cleanCookie, { expires: 7, path: '/' });
        favoriteButton.classList.remove('favorited');
    }
    else {
        if (setFavorites === undefined || setFavorites === '') {
            (0, typescript_cookie_1.setCookie)('favoriteVacancies', vacancyId, { expires: 7, path: '/' });
        }
        else {
            (0, typescript_cookie_1.setCookie)('favoriteVacancies', (0, typescript_cookie_1.getCookie)('favoriteVacancies') + ',' + vacancyId, {
                expires: 7,
                path: '/',
            });
        }
        favoriteButton.classList.add('favorited');
    }
}
function initAddToFavorite() {
    document === null || document === void 0 ? void 0 : document.querySelectorAll('.vacancy .favorite').forEach((favoriteButton) => favoriteButton.addEventListener('click', (e) => addToFavorite(e, favoriteButton)));
}
exports.initAddToFavorite = initAddToFavorite;
